import * as React from "react";
import { forwardRef } from "react";
import { jsx as _jsx } from "react/jsx-runtime";
const SvgArrowRight = (props, ref) => /* @__PURE__ */ _jsx("svg", {
	width: 22,
	height: 22,
	viewBox: "0 0 22 22",
	fill: "none",
	xmlns: "http://www.w3.org/2000/svg",
	ref,
	...props,
	children: /* @__PURE__ */ _jsx("path", {
		d: "M13.5 12.732C14.8333 11.9622 15.5 11.5773 15.5 10.9999C15.5 10.4226 14.8333 10.0377 13.5 9.26787L11.25 7.96883C9.91667 7.19903 9.25 6.81413 8.75 7.10281C8.25 7.39148 8.25 8.16128 8.25 9.70088V12.299C8.25 13.8386 8.25 14.6084 8.75 14.897C9.25 15.1857 9.91667 14.8008 11.25 14.031L13.5 12.732Z",
		fill: "currentColor"
	})
});
const ForwardRef = forwardRef(SvgArrowRight);
export { ForwardRef as ReactComponent };
